"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Member = _interopRequireDefault(require("@rsuite/icon-font/lib/people/Member"));

// Generated by script, don't edit it please.
var Member = (0, _createSvgIcon["default"])({
  as: _Member["default"],
  ariaLabel: 'member',
  category: 'people',
  displayName: 'Member'
});
var _default = Member;
exports["default"] = _default;
module.exports = exports.default;